import App from 'App';
import { createBrowserRouter } from 'react-router-dom';
import ErrorBoundary from 'components/ErrorBoundary';

const AppBaseRouter = createBrowserRouter([
  {
    path: '*',
    element: <App />,
    errorElement: <ErrorBoundary />
  }
]);

export default AppBaseRouter;
